var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHevenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 33,
    viewBox: "0 0 98 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2811 19.6931L85.6857 7.88038H79.4604V32.835H85.3709V21.6711L90.9663 32.835H97.1914V7.88038H91.2811V19.6931Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.73 32.835H76.8341V26.9247H67.6402V21.6711H74.8639V15.7608H67.6402V13.7906H76.8341V7.88038H61.73V32.835Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2227 11.8206L55.1629 10.5072L50.5661 18.3877L54.5061 17.0743L46.6259 30.865L48.5959 20.3577L44.6376 21.6711L46.6259 14.4474L42.6856 15.7608L44.6556 7.88038H36.7754L43.3422 32.835H53.8495L60.4166 7.88038H53.1927L51.2227 11.8206Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3579 32.835H35.462V26.9247H26.2681V21.6711H33.4918V15.7608H26.2681V13.7906H35.462V7.88038H20.3579V32.835Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8207 15.7531L5.91045 16.9519V7.88038H0V32.835H5.91045V22.9826L11.8207 21.7838V32.835H17.7309V7.88038H11.8207V15.7531Z",
    fill: "#081231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.9104H97.1917V0.000161648H0V5.9104Z",
    fill: "#081231"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.1917,
    height: 32.8349,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHevenLogo);
export default __webpack_public_path__ + "static/media/heven-logo.c6206bc221fc6abace1cd03dc2c5ec08.svg";
export { ForwardRef as ReactComponent };